import { Link } from "react-router-dom";
import useFormValidationLogin from "../../Hooks/LoginHook";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { PiEyeSlashThin } from "react-icons/pi";
import { PiEyeThin } from "react-icons/pi";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const {
    formData,
    errors,
    resDataError,
    isLoading,
    handleInputChange,
    handleSubmit,
    handleShow,
    show,
  } = useFormValidationLogin();
  const { userType } = useContext(AuthContext);
  const navigate = useNavigate()

  return (
    <div className="signeup-account">
      <ToastContainer/>
      <div className="content-card">
      <div className="wrap">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <Link to="/choose_login" >Back</Link>
        </div>
        <form onSubmit={handleSubmit}>
          <h3>Login account</h3>
          <p>For {userType}</p>
          <label>
            <input
              type="email"
              placeholder="Enter Email address"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </label>

          <label>
            <span>
              <input
                type={show ? "text" : "password"}
                placeholder="Enter Password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />

              {show ? (
                <PiEyeSlashThin onClick={handleShow} />
              ) : (
                <PiEyeThin onClick={handleShow} />
              )}
            </span>
            {errors.password && (
              <p className="error">
                {Array.isArray(errors.password)
                  ? errors.password[0]
                  : errors.password}
              </p>
            )}
          </label>

          <div className="btn">
            <button type="submit" disabled={isLoading}>
              {isLoading ? "authorization...." : "Continue"}
            </button>
            <Link to="/Forgotpassword">Forgot Password?</Link>
          </div>

          {resDataError && <p className="error">{resDataError}</p>}

          <div className="agree">
            <p>
              By continuing, you agree to vatug's{" "}
              <a href="/">Terms of Service</a> and{" "}
              <a href="/">Privacy Policy</a>
            </p>
            <span>
              Don't have an account? <Link to="/Signup">Sign Up</Link>
            </span>
          </div>
        </form>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default Login;
